<script setup lang="ts">
import { PropType } from "vue";
import { stylesToClasses } from "@/builder/BuilderUtilities";
import { ITextComponent } from "../../interfaces";

defineProps({
    component: {
        type: Object as PropType<ITextComponent>,
        required: true
    },
    text: {
        type: String,
        required: true
    }
});

</script>

<template>
    <div class="text-container rd-w-full" :style="stylesToClasses(component.styles)" v-html="text"></div>
</template>
